export const CatMascot = ({ size = 40, glow = true }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="eyeGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#C4B5FD" />
        <stop offset="60%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#6D28D9" />
      </radialGradient>
    </defs>
    <path d="M22 30 L15 8 L38 22 Q50 18 62 22 L85 8 L78 30 Q92 45 88 65 Q80 92 50 92 Q20 92 12 65 Q8 45 22 30 Z" fill="#0B0D12" stroke="#1E2436" strokeWidth="2"/>
    <ellipse cx="37" cy="52" rx="8" ry="11" fill="url(#eyeGlow)" style={glow ? { filter: "drop-shadow(0 0 6px #8B5CF6)" } : {}}/>
    <ellipse cx="63" cy="52" rx="8" ry="11" fill="url(#eyeGlow)" style={glow ? { filter: "drop-shadow(0 0 6px #8B5CF6)" } : {}}/>
    <ellipse cx="37" cy="52" rx="3" ry="7" fill="#1a1030"/>
    <ellipse cx="63" cy="52" rx="3" ry="7" fill="#1a1030"/>
    <path d="M47 66 L53 66 L50 70 Z" fill="#8B5CF6"/>
    <path d="M50 70 Q44 74 40 71 M50 70 Q56 74 60 71" stroke="#4C1D95" strokeWidth="1.5" fill="none"/>
  </svg>
);

export default CatMascot;
